import { animate, state, style, transition, trigger } from '@angular/animations';

export const Animations = {
  toggleAnimation: trigger('expandCollapseItem', [
    state(
      'void',
      style({
        height: 0
      })
    ),
    transition(':enter', [
      animate(
        '200ms ease',
        style({
          height: '*',
          'padding-top': '*',
          'padding-bottom': '*'
        })
      )
    ]),
    transition(':leave', [
      animate(
        '200ms ease',
        style({
          height: 0,
          'padding-top': 0,
          'padding-bottom': 0
        })
      )
    ])
  ]),
  preventFirstAnimation: trigger('preventFirstAnimation', [transition(':enter', [])])
};
